<template>
  <div class="authenticated">
    <div class="nav-bg container-fluid">
      <navigation></navigation>
    </div>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger" />
        <alert v-if="isMessage" type="primary" />
        <h1>Confirmation Form</h1>
        <b-form>
          <div v-if="step === 1">
            <h3>Registration and Visa Information</h3>
            <b-form-group>
              <p>
                Your conference registration will come from the Student
                Volunteer Program. Please do <strong>NOT</strong> register for
                SIGGRAPH on your own. A registration code will be sent to you via email in the coming weeks.
              </p>
              <p>If you require a letter of invitation to travel to SIGGRAPH 2026
                in Los Angeles, please make sure to indicate this when you register for the conference using the code we send you.</p>
            </b-form-group>
            <h3>Passport</h3>
            <b-form-group>
              <p>
                Select your current passport status (Please be sure to check the
                expiration date!)
              </p>
              <b-form-radio-group
                id="passport-status"
                v-model="form.passportStatus"
                name="passportStatus"
                stacked
                class="radio"
              >
                <b-form-radio value="noPassport"
                  >I do not require a passport to volunteer at SIGGRAPH 2026 in
                  Los Angeles as I am already located in the United States.</b-form-radio
                >
                <b-form-radio value="havePassport"
                  >I have a current passport valid through at least September
                  2026.</b-form-radio
                >
                <b-form-radio value="needPassport"
                  >I will acquire a valid passport by 1 July
                  2026.</b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
            <h3>On-Site Communication</h3>
            <b-form-group>
              <p>
                This year we will be using Discord for on-site communication with all the 
                Student Volunteers, Team Leaders, and Student Volunteer Sub-Committee (SVSC) members. 
                We will send an invitation to join the Discord server to your email inbox.
              </p>
            </b-form-group>
            <!--<b-form-group>
              <p>If you require a letter of invitation to travel to SIGGRAPH 2023 in Los Angeles, copy the information
                below filled with your information, and email it to Lauren Matthews, at <a
                  href="mailto:BAlpert@smithbucklin.com">BAlpert@smithbucklin.com</a>.</p>
              <p>If you are not required to obtain a visa to travel to the United States, you do <strong>NOT</strong> have
                to go through this process.</p>
              <p><strong>NOTE:</strong> Your conference registration will come from the Student Volunteer Program. If you
                require a letter of invitation, you <strong>MUST</strong> obtain your invitation letter directly from
                Brian.</p>
              <div class="form-template">
                <p>I am a Student Volunteer and would like to request a visa letter.</p>
                <ul>
                  <li>Full name (matching what is on my passport): ____________ </li>
                  <li>Full address (matching what is on my passport): ____________ </li>
                  <li>Country (matching what is on my passport): ____________ </li>
                  <li>Primary email address: ____________ </li>
                  <li>After the conference, I will be returning to: ____________ </li>
                </ul>
                <p><strong>It is important that you indicate if you will be returning to your home country or going back
                    to school.</strong></p>
              </div>
            </b-form-group> -->
            <h3>T-Shirt Size</h3>
            <b-form-group>
              <p>Every in-person Student Volunteer will be given 2 SV t-shirts at SV Check-In. It is mandatory to wear an SV t-shirt while on-shift.</p>
              <b-form-select id="shirtSize" v-model="form.shirtSize" :options="shirtSizes" class="mb-3">
              </b-form-select>
            </b-form-group>
            <h3>Dietary Restrictions</h3>
            <p>Do you have any dietary restrictions?</p>
            <b-form-radio-group id="dietaryRestrictions" v-model="form.diet" name="dietaryRestictions" stacked class="radio">
              <b-form-radio :value=false>No</b-form-radio>
              <b-form-radio :value=true>Yes, I have the following dietary restrictions: <b-form-input :disabled="!form.diet" name="dietaryRestrictions" v-model="form.dietRestrictions" type="text" placeholder="please list any dietary restrcitions"></b-form-input></b-form-radio>
            </b-form-radio-group>
          </br>
            <h3>Health and Safety</h3>
            <b-form-group>
              <p>
                Your health and safety is a priority for SIGGRAPH 2026. As we approach our in-person experience in Los Angeles, check back <a href="https://s2026.siggraph.org/health-safety">here</a> for the latest health and safety information.
              </p>
            </b-form-group>
            <h3>Email Consent</h3>
            <b-form-group>
              <p>
                From time to time, SIGGRAPH conference, SIGGRAPH contractors,
                ACM SIGGRAPH Standing Committees or Sponsors might send emails
                to Student Volunteers such as:
              </p>
              <ul style="list-style-type:square; padding-left: 15px">
                <li>
                  Announcements about upcoming deadlines related to the Student
                  Volunteer Program or other SIGGRAPH conference programs.
                </li>
                <li>
                  Information about professional development opportunities (e.g.
                  Portfolio / Reel Review by S3 Committee) or other activities
                  organized by ACM SIGGRAPH committees.
                </li>
                <li>
                  Where we have the consent of Student Volunteers, emails
                  targeted at this specific groups. Only ACM SIGGRAPH related
                  staff or volunteers can create and support email distribution
                  lists with data from Student Volunteers.
                </li>
              </ul>
              <p>
                The SIGGRAPH Student Volunteer Program, or any other ACM
                SIGGRAPH related entity does not sell, rent, or exchange email
                addresses of its Student Volunteers. If at any time you decide
                that you no longer wish to receive any of the emails described
                above, you may do so by using the "unsubscribe" instructions set
                out at the bottom of each email, or by informing the
                corresponding party.
              </p>
              <b-form-checkbox v-model="form.emailConsent"
                >I consent</b-form-checkbox
              >
            </b-form-group>
            <h3>Photo and Video Consent</h3>
            <b-form-group>
              <p>
                Photos and videos can be taken in the course of the conference
                and any other audio-visual material can be produced.
              </p>
              <p>
                By participating at SIGGRAPH you agree that photos, videos and
                any other audio-visual material of the event are taken on which
                you are visible but wherein your person is not the central point
                of focus. We have a legitimate interest in using such photos,
                videos and other audio-visual material for the promotion and
                experience of our Student Volunteer Program and other SIGGRAPH
                related activities.
              </p>
              <p>
                Pictures and other audio-visual material wherein you are the
                central point of focus can also be taken. We have a legitimate
                interest to use these photos and audio-visual material in
                brochures, posters, general marketing material and on the
                SIGGRAPH website for the promotion of the conference and the
                future editions of it. You have the right to request the removal
                of these photos. You can do so by sending an e-mail to
                <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>
                with your surname, name and the indication of the photo or video
                in question.
              </p>
              <b-form-checkbox v-model="form.photoConsent"
                >I consent</b-form-checkbox
              >
            </b-form-group>
            <h3>ACM SIGGRAPH Student Membership</h3>
            <b-form-group>
              <p>
                Accepted Student Volunteers may have the opportunity to receive an 
                ACM SIGGRAPH Student Membership from a limited number of available memberships.
                If you would like to be considered for a membership, please opt-in below.
              </p>
              <b-form-checkbox v-model="form.wantsMembership"
                >I would like to recieve an ACM SIGGRAPH Student
                Membership.</b-form-checkbox
              >
            </b-form-group>
            <h3>Additional Information</h3>
            <b-form-group>
              <p>
                Is there any additional information you would like to share with
                the Student Volunteer Subcommittee? Is there any information we
                should know when assigning you to conference program shifts?
              </p>
              <p>
                This can regard medical or mental conditions, fears, or any
                other information that can help us make your experience as an SV
                more comfortable. All answers will remain confidential.
              </p>
              <b-form-textarea
                id="additional-info"
                v-model="form.additionalInfo"
                :rows="4"
              >
              </b-form-textarea>
            </b-form-group>
          </div>

          <div v-if="step === 2">
            <h3>Special Shift Requests</h3>
            <p>
              There are over 70 different types of Student Volunteer shifts.
              Many shifts are general customer service roles like monitoring
              doors and providing information for attendees. However, there are
              several shifts which require more focused skills and interests
              (i.e., writing, foreign language skills, software demonstrations,
              social media, etc.); these shifts are outlined below.
            </p>
            <p>
              If you are interested in any of the shifts listed below, please
              read through the descriptions and fill out the questions in this
              form.
              <strong
                >Please note that shift assignments to your preferences are not
                guaranteed</strong
              >. Special shifts will be assigned alongside other shifts prior to
              the conference.
            </p>
            <b-tabs pills vertical card class="applicationWizard" style="margin-bottom: 1rem;">
              <b-tab title="Pre-Conference Shifts ('Setup')" active>
                <p>
                  Are you planning to arrive in Los Angeles earlier than July
                  18th?
                </p>
                <p>
                  If so, you can take advantage of our pre-conference shifts
                  which will allow you to fulfill some of your hour commitment
                  prior to the start of SIGGRAPH. Pre-conference shifts will
                  start the morning of Friday, July 17th.
                </p>
                <b-form-checkbox v-model="form.preconfShifts"
                  >I'm interested and guarantee that I WILL arrive early in Los Angeles
                  to work my assigned pre-conference shifts</b-form-checkbox
                >
                <b-form-group v-if="form.preconfShifts">
                  <label for="preconfStart"
                    >Which day are you able to start?</label
                  >
                  <b-form-radio-group
                    id="preconf-start"
                    v-model="form.preconfStart"
                    name="preconfStart"
                    class="radio"
                  >
                    <b-form-radio value="friday"
                      >Friday, July 17th</b-form-radio
                    >
                    <b-form-radio value="saturday"
                      >Saturday, July 18th</b-form-radio
                    >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group v-if="form.preconfShifts">
                  <p>
                    If you are flying, please make sure that you factor in
                    travel time from the airport to the Los Angeles Convention Center. 
                    Also note all times are Pacific Daylight Time (PDT/UTC-7).
                  </p>
                  <label for="preconfStartTime"
                    >What time will you be able to start a shift?</label
                  >
                  <b-form-select
                    name="preconfStartTime"
                    id="preconf-start-time"
                    v-model="form.preconfStartTime"
                    :options="startTimes"
                    class="mb-3"
                  >
                  </b-form-select>
                </b-form-group>
              </b-tab>
              <b-tab title="Art Gallery">
                <p>
                  The Art Gallery is a selectively curated showcase of the most
                  thought-provoking and innovative art made by technologists,
                  engineers, and fine artists in the SIGGRAPH community and
                  across the world.
                </p>
                <p>
                  Students Volunteers in the Art Gallery get to work directly
                  with artists explaining and sharing the works with conference
                  attendees. We are looking for students with excellent and
                  enthusiastic communication skills (especially those who have a
                  talent for explaining abstract concepts to others) and are
                  interested in fine art, mixed media, and curation or museum
                  studies.
                </p>
                <b-form-checkbox v-model="form.artGallery"
                  >I'm interested</b-form-checkbox
                >
              </b-tab>
              
              <b-tab title="Labs">
                <p>
                  Labs presentations will be in-person at the conference and
                  should allow participants to get their hands dirty with the
                  subject being presented. Potential submissions include (but
                  are not limited to): working details from the Technical
                  Papers, Art Papers, or other SIGGRAPH 2026 programs;
                  discussions about prototyping and design in practice;
                  technology overviews from experts in their field; use of AR/VR
                  design tools; adaptive technology; high-speed imaging systems;
                  motion-capture systems; stop-motion animation software;
                  rapid-prototyping machines; interactive drawing tools;
                  physical computing devices or objects; and exploratory
                  platforms. We are looking for students who are interested in
                  demonstrating new technologies and interested in encouraging
                  attendees to participate.
                </p>
                <b-form-checkbox v-model="form.labs"
                  >I'm interested</b-form-checkbox
                >
              </b-tab>
              <b-tab title="Immersive Pavillion">
                <p>
                  The SIGGRAPH 2026 Immersive Pavilion gathers outstanding
                  content in virtual reality, augmented reality, mixed reality,
                  and beyond! This year's in-person event is a place for
                  contributors and participants to engage in critical discourse
                  on the latest interactive breakthroughs. We are looking for
                  students who help manage the attendees in a formal way to test
                  out the experiences. Additionally, students might need to
                  periodically help contributors get attendees in and out of
                  their stations, organize the attendees in lines (logistics),
                  or provide attendees information about how we are keeping
                  things sanitized.
                </p>
                <b-form-checkbox v-model="form.pavillion"
                  >I'm interested</b-form-checkbox
                >
              </b-tab>
            </b-tabs>
            <p>
              By confirming your position, you are committing to be an in-person
              Student Volunteer at SIGGRAPH 2026 during the week of 18th July - 23rd July 2026.
            </p>
          </div>

          <b-form-group>
            <button
              v-if="step === 1"
              type="submit"
              class="btn arrow-btn-primary float-right"
              @click="nextStep"
            >
              Next Step
            </button>
            <button
              v-if="step === 2"
              type="submit"
              class="btn left-arrow-btn-primary float-left"
              @click="previousStep"
            >
              Previous Step
            </button>
            <button
              v-if="step === 2"
              :disabled="disabled"
              type="submit"
              class="btn arrow-btn-primary float-right"
              @click="submitConfirmation"
            >
              Submit
            </button>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '@/router'
import Alert from '@/components/Alert'
import Nav from '@/components/Nav'
import { startTimes, shifts, shirtSizes } from '@/util/SelectLists'

export default {
  name: 'Confirmation',
  data () {
    return {
      form: {
        passportStatus: null,
        wantsMembership: false,
        additionalInfo: '',
        preconfShifts: false,
        preconfStart: 'friday',
        preconfStartTime: '12:00',
        artGallery: false,
        labs: false,
        pavillion: false,
        emailConsent: false,
        photoConsent: false,
        shirtSize: '',
        diet: false,
        dietRestrictions: ''
      },
      step: 1,
      startTimes: startTimes,
      shifts: shifts,
      disabled: false,
      shirtSizes: shirtSizes
    }
  },
  computed: {
    ...mapGetters(['isError', 'isMessage'])
  },
  methods: {
    nextStep (e) {
      e.preventDefault()
      if (this.form.passportStatus === null) {
        this.$store.commit('error', {
          message: 'Please select a passport status.'
        })
      } else if (this.form.shirtSize === '') {
        this.$store.commit('error', {
          message: 'Please select a t-shirt size.'
        })
      } else if (this.form.diet && this.form.dietRestrictions === '') {
        this.$store.commit('error', {
          message: 'Please describe your dietary restrictions below.'
        })
      } else if (!this.form.emailConsent) {
        this.$store.commit('error', {
          message: 'Please consent to the email policy.'
        })
      } else if (!this.form.photoConsent) {
        this.$store.commit('error', {
          message: 'Please consent to the photo and video policy.'
        })
      } else {
        this.$store.commit('clearError')
        this.step++
      }
      window.scrollTo(0, 0)
    },
    previousStep (e) {
      e.preventDefault()
      this.step = 1
      window.scrollTo(0, 0)
    },
    submitConfirmation (e) {
      e.preventDefault()
      this.disabled = true
      this.$store
        .dispatch('user/submitConfirmation', { data: this.form })
        .then(() => {
          // Reload application again to get the new status
          this.$store.dispatch('application/load')
          router.push('/')
          this.disabled = false
        })
        .catch((e) => {
          this.disabled = false
        })
    }
  },
  components: {
    alert: Alert,
    navigation: Nav
  },
  created: function () {
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes')
    }
    if (this.$store.state.application.data.haveVolunteered) {
      this.form.priorSv = true
    }
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss">
// .form-template {
//   margin: 10px 30px;
//   padding: 10px;
//   background: #eaebee;
// }

// .radio {
//   margin: 10px 30px;

//   .custom-radio {
//     margin: 10px 0px;
//   }
// }

// .application .form-group {
//   margin: 10px 20px;

//   p {
//     line-height: 1.5;
//   }

//   #dietary-restrictions label {
//     display: inline !important;
//   }
// }

// .application .card-header a {
//   color: #007cb5;
// }
</style>



// WEBPACK FOOTER //
// src/components/Confirmation.vue